import { useEffect } from "react";
import useLanguages from "../hooks/useLanguages";
import { ensureGoogleTranslateLoaded } from "./googleTranslate";
import { findDefaultLanguage } from "../services/languageService";
import { whenIdle } from "../lib/deferIdle";

/**
 * Renders nothing — mounted once at the app root (alongside the
 * other always-on floats in App.js) so Google Translate's script
 * loads and initializes exactly once for the whole session, scoped
 * to whatever languages the admin currently has enabled.
 */
export default function GoogleTranslateInit() {
  const { languages, loading } = useLanguages();

  useEffect(() => {
    if (loading || languages.length === 0) return;
    const defaultLang = findDefaultLanguage(languages);
    // Google's element.js is a heavy third-party script; hold it until the
    // page is idle so it never blocks the hero paint.
    whenIdle(() =>
      ensureGoogleTranslateLoaded(
        languages.map((l) => l.code),
        defaultLang?.code || "en"
      )
    );
  }, [loading, languages]);

  return null;
}
